'use strict';

var getProductAvailabilityLabel = {};

exports.__exports = getProductAvailabilityLabel;
//# sourceMappingURL=getProductAvailabilityLabel.cjs.map
